// src/components/FeatureGate.jsx
import { useFeatureFlag } from '../hooks/useFeatureFlag'

// Usage:
// <FeatureGate feature="persistent_history">
//   <ComponentThatRequiresPro />
// </FeatureGate>
//
// Optional fallback for upsell UI:
// <FeatureGate feature="full_armory" fallback={<UpgradePrompt />}>
//   <FullArmory />
// </FeatureGate>

export default function FeatureGate({ feature, orgTier = null, fallback = null, children }) {
  const allowed = useFeatureFlag(feature, orgTier)
  if (!allowed) return fallback
  return children
}